/**
 * One article of an offer request together with the requested quantity.
 * Positions are copied from the cart when the request is created and can be
 * edited afterwards, so the request no longer depends on the cart.
 */
export class OfferRequestPositionDto {
	public articleId: number = 0;
	/** Quantity the customer wants an offer for. */
	public quantity: number = 1;
	/** True when this position is part of the first article inspection. */
	public isSelectedForInspection: boolean = false;
	/** Quantity to be sampled. Zero while the position is not part of the inspection. */
	public inspectionQuantity: number = 0;
}
